import icX from 'assets/images/ic-x.svg'
import { Button, Checkbox, Modal } from 'avo-ui'
import { getRatingImage } from 'utils/utils'
import { useEffect, useState } from 'react'

export const RatingFilterModal = ({ show, onHide, values = [], onFilter }) => {
    const [checkList, setCheckList] = useState([])

    const checkedHandler = (key) => {
        let newData
        if (key?.checked) {
            newData = [key?.value].concat(checkList)
        } else {
            newData = checkList?.filter((i) => i !== key?.value)
        }

        setCheckList(newData)
    }

    useEffect(() => {
        setCheckList(values)
    }, [show])

    return (
        <Modal dialogClassName={'max-w-[250px]'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <div className={'flex flex-row px-3 py-5 items-center justify-between'}>
                <div />
                <p className={'font-bold text-blue-90 text-lg mt-2'}>Filter</p>
                <img className={'w-5 -mt-8 cursor-pointer'} src={icX} alt='ic-x' onClick={onHide} />
            </div>
            <div className={'col space-y-4 max-h-64 overflow-scroll pr-10'}>
                <div className={'mb-2'}>
                    <p className={'text-blue-90 capitalize font-semibold pl-5 pb-2'}>Rating</p>
                    {[5, 4, 3, 2, 1].map((item, index) => (
                        <div key={index} className={'pl-5 py-3 w-full'}>
                            <Checkbox
                                key={`${item}-${index.toString()}`}
                                label={
                                    <div className={'flex space-x-1'}>
                                        {getRatingImage(item).map((i, index) => (
                                            <img key={`${index}${i}`} src={i} alt={item} />
                                        ))}
                                    </div>
                                }
                                name={`rating-${item?.toString()}`}
                                value={item}
                                checked={checkList?.includes(item?.toString())}
                                onChange={(value) => checkedHandler(value)}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className={'flex flex-row px-6 py-3 space-x-3 justify-center'}>
                <Button type={'outline'} title={'Cancel'} onClick={onHide} />
                <Button title={'Submit'} onClick={() => onFilter(checkList)} />
            </div>
        </Modal>
    )
}
